// Remembers the in/cm choice across size charts (blocks/nba-size-chart.liquid). Loaded on every
// page because quick-add, mostly used on collection pages, inserts charts whose own scripts never
// run. The saved unit is applied as a chart's link is clicked, before its pop-up opens.
const key = 'nba-size-unit';

document.addEventListener('change', (event) => {
  if (!event.target.matches?.('.nba-size-chart__units input')) return;
  try {
    localStorage.setItem(key, event.target.value);
  } catch (error) {}
});

document.addEventListener(
  'click',
  (event) => {
    const chart = event.target.closest?.('.nba-size-chart__link')?.closest('.nba-size-chart');
    if (!chart) return;
    let saved = null;
    try {
      saved = localStorage.getItem(key);
    } catch (error) {}
    const input = chart.querySelector(`.nba-size-chart__units input[value="${saved}"]`);
    if (input) input.checked = true;
  },
  true
);
